import Vue from 'vue';
import 'babel-polyfill';
import axios from 'axios';
import Slick from 'vue-slick';

/*axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}*/

const app = new Vue({
    el: "#app",
    data: {
        city: country.data,
        weatherResult: [],
        key: api_key,
        slickOptions: {
            infinite: true,
            fade: true,
            cssEase: 'linear'
        },
    },
    components: {
        Slick
    },
    mounted: function () {
        var app_id = this.key;
        var current_url = "https://api.openweathermap.org/data/2.5/weather";
        var week_url = "https://api.openweathermap.org/data/2.5/forecast";
        var _this = this;

        //let getWeather = new Promise((resolve, reject) => {
            $.each(_this.city, function (index, value) {
                var array = {};
                var params = {
                    q: value.en_city,
                    appid: app_id
                };

                axios.get(current_url, {
                    params: params
                }).then((response) => { 
                    response.data.name = value.tw_city;
                    response.data.now = moment().format('YYYY-MM-DD');
                    array.current = response.data;
                    return axios.get(week_url, {
                        params: params
                    })
                }).then((response) => { 
                    var week = response.data.list.filter(function(item, index, array) {
                        if (moment(item.dt_txt).format('YYYY-MM-DD') != moment().format('YYYY-MM-DD')) {
                            return item;
                        }                        
                    });
                    array.week = week;
                    _this.weatherResult.push(array); 
                    //resolve('ok');
                }).catch(error => console.log(error));
            });
        //});
    },
    beforeUpdate() {
        if (this.$refs.slick) {
            this.$refs.slick.destroy();
        }
    },
    updated() {
        this.$nextTick(function () {
            if (this.$refs.slick) {
                this.$refs.slick.create(this.slickOptions);
            }
        });
    },
    methods: {
        getCelsius: function (temp) {
            var celsius = parseFloat(temp) - 273.15;
            return celsius.toFixed(1);
        },
        getDay: function (date) {
            var day = moment(date).format('dddd');
            switch (day) {
                case 'Sunday':
                    return '日';
                case 'Monday':
                    return '一';
                case 'Tuesday':
                    return '二';
                case 'Wednesday':
                    return '三';
                case 'Thursday':
                    return '四';
                case 'Friday':
                    return '五';
                case 'Saturday':
                    return '六';
            };
        },
        getWeather: function (weather) {
            switch (weather) {
                case 'Mostly Sunny':
                    return '晴時多雲';
                case 'Sunny':
                    return '晴天';
                case 'Fair':
                    return '晴朗';
                case 'Rain':
                    return '雨天';
                case 'Clouds':
                    return '多雲';
                case 'Mostly Cloudy':
                    return '多雲時陰';
                case 'Scattered Showers':
                    return '零散陣雨';
                case 'Partly Cloudy':
                    return '局部多雲';
                case 'Isolated Thunderstorms':
                    return '局部雷雨';
                case 'Scattered Thunderstorms':
                    return '零散雷雨';
                case 'Showers':
                    return '陣雨';
                case 'Tornado':
                    return '龍捲風';
                case 'Tropical Storm':
                    return '熱帶暴風';
                case 'Hurricane':
                    return '颶風';
                case 'Severe Thunderstorms':
                    return '劇烈雷雨';
                case 'Thunderstorms':
                    return '雷雨';
                case 'Rain And Snow':
                    return '雨夾雪';
                case 'Rain And Sleet':
                    return '半凍雨';
                case 'Snow And Sleet':
                    return '下雪';
                case 'Freezing Drizzle':
                    return '凍毛雨';
                case 'Drizzle':
                    return '毛毛雨';
                case 'Freezing Rain':
                    return '凍雨';
                case 'Snow Flurries':
                    return '陣雪';
                case 'Light Snow Showers':
                    return '飄雪';
                case 'Blowing Snow':
                    return '風雪';
                case 'Snow':
                    return '下雪';
                case 'Hail':
                    return '冰雹';
                case 'Sleet':
                    return '雨夾雪';
                case 'Dust':
                    return '塵暴';
                case 'Foggy':
                    return '起霧';
                case 'Haze':
                    return '霾';
                case 'Smoky':
                    return '煙';
                case 'Breezy':
                    return '微風';
                case 'Blustery':
                    return '狂風';
                case 'Windy':
                    return '起風';
                case 'Cold':
                    return '冷';
                case 'Clear':
                    return '無雲';
                case 'Rain And Hail':
                    return '雹雨參雜';
                case 'Hot':
                    return '熱';
                case 'Heavy Snow':
                    return '暴雪';
                case 'Sattered Snow Showers':
                    return '零散陣雪';
                case 'Thundershowers':
                    return '雷雪';
                case 'Snow Showers':
                    return '陣雪';
                default:
                    return weather;
            }
        },
        getImage: function (weather) {
            switch (weather) {
                case 'Mostly Sunny':
                    return '/images/weather/01-sunny.png';
                case 'Sunny':
                    return '/images/weather/01-sunny.png';
                case 'Fair':
                    return '/images/weather/01-sunny.png';
                case 'Rain':
                    return '/images/weather/03-rainy.png';
                case 'Clouds':
                    return '/images/weather/02-cloudy.png';
                case 'Mostly Cloudy':
                    return '/images/weather/02-cloudy.png';
                case 'Scattered Showers':
                    return '/images/weather/04-heavy-rainy.png';
                case 'Partly Cloudy':
                    return '/images/weather/02-cloudy.png';
                case 'Isolated Thunderstorms':
                    return '/images/weather/05-thunder.png';
                case 'Scattered Thunderstorms':
                    return '/images/weather/05-thunder.png';
                case 'Showers':
                    return '/images/weather/04-heavy-rainy.png';
                case 'Tornado':
                    return '/images/weather/10-tornado.png';
                case 'Tropical Storm':
                    return '/images/weather/08-wind.png';
                case 'Hurricane':
                    return '/images/weather/08-wind.png';
                case 'Severe Thunderstorms':
                    return '/images/weather/05-thunder.png';
                case 'Thunderstorms':
                    return '/images/weather/05-thunder.png';
                case 'Rain And Snow':
                    return '/images/weather/06-snow.png';
                case 'Rain And Sleet':
                    return '/images/weather/06-snow.png';
                case 'Snow And Sleet':
                    return '/images/weather/06-snow.png';
                case 'Freezing Drizzle':
                    return '/images/weather/03-rainy.png';
                case 'Drizzle':
                    return '/images/weather/03-rainy.png';
                case 'Freezing Rain':
                    return '/images/weather/03-rainy.png';
                case 'Snow Flurries':
                    return '/images/weather/07-heavy-snow.png';
                case 'Light Snow Showers':
                    return '/images/weather/06-snow.png';
                case 'Blowing Snow':
                    return '/images/weather/06-snow.png';
                case 'Snow':
                    return '/images/weather/06-snow.png';
                case 'Hail':
                    return '/images/weather/11-fog.png';
                case 'Sleet':
                    return '/images/weather/06-snow.png';
                case 'Dust':
                    return '/images/weather/11-fog.png';
                case 'Foggy':
                    return '/images/weather/11-fog.png';
                case 'Haze':
                    return '/images/weather/11-fog.png';
                case 'Smoky':
                    return '/images/weather/11-fog.png';
                case 'Breezy':
                    return '/images/weather/08-wind.png';
                case 'Blustery':
                    return '/images/weather/08-wind.png';
                case 'Windy':
                    return '/images/weather/08-wind.png';
                case 'Cold':
                    return '/images/weather/06-snow.png';
                case 'Clear':
                    return '/images/weather/01-sunny.png';
                case 'Rain And Hail':
                    return '/images/weather/03-rainy.png';
                case 'Hot':
                    return '/images/weather/01-sunny.png';
                case 'Heavy Snow':
                    return '/images/weather/07-heavy-snow.png';
                case 'Sattered Snow Showers':
                    return '/images/weather/07-heavy-snow.png';
                case 'Thundershowers':
                    return '/images/weather/05-thunder.png';
                case 'Snow Showers':
                    return '/images/weather/07-heavy-snow.png';
                default:
                    return '/images/weather/02-cloudy.png';
            }
        },
        getDate: function (date, format) {
            return moment(date).format(format);
        },
        next() {
            this.$refs.slick.next();
        },
        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
    }
});


// WEBPACK FOOTER //
// ./resources/assets/weather.js